import { render, staticRenderFns } from "./AddDistributionOption.vue?vue&type=template&id=5cb65425&scoped=true&"
import script from "./AddDistributionOption.vue?vue&type=script&lang=js&"
export * from "./AddDistributionOption.vue?vue&type=script&lang=js&"
import style0 from "./AddDistributionOption.vue?vue&type=style&index=0&id=5cb65425&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb65425",
  null
  
)

export default component.exports